import Facebook from "./img/facebook.svg";
import Instagram from "./img/instagram.svg";
import Google from "./img/google.svg";
import Pinterest from "./img/pinterest.svg";
import Message from "./img/message.svg";
import Magazine from "./img/magazine.svg";
import Radio from "./img/radio.svg";
import Other from "./img/other.svg";
import getApiUrl from "./utils/getApiUrl";
import GET from "./utils/GET";

const publisher = GET("publisher");
const orderId = GET("identifier");

export const SURFACE_TYPES = {
	OFFER: "offer",
	SURVEY: "survey",
	CUSTOM_POST: "custom_post",
	REWARD: "rewards",
};

export const SURFACE_DATA_KEY = {
	[SURFACE_TYPES.OFFER]: "offer",
	[SURFACE_TYPES.SURVEY]: "survey_question",
	[SURFACE_TYPES.REWARD]: "rewards",
	[SURFACE_TYPES.CUSTOM_POST]: "custom_post",
};

// core/modules/<publisher_id>/
export const surveyOptions = [
	{ icon_url: Facebook, text: "Facebook", extra_text: "on" },
	{ icon_url: Instagram, text: "Instagram", extra_text: "on" },
	{ icon_url: Google, text: "Google", extra_text: "on" },
	{ icon_url: Pinterest, text: "Pinterest", extra_text: "on" },
	{ icon_url: Message, text: "Friends or Family", extra_text: "through" },
	{ icon_url: Radio, text: "Radio", extra_text: "by" },
	{ icon_url: Magazine, text: "Magazine or print", extra_text: "using" },
	{ icon_url: Other, text: "Other", extra_text: "using" },
];

export const referalOptions = [
	{
		icon: true,
		icon_url: "🎉",
		text: "Yes! I can do that right now.",
		extra_text: "",
	},
	{
		icon: true,
		icon_url: "👜",
		text: "Yes, if both my friend and I get $10 gift cards!",
		extra_text: "",
	},
	{
		icon: true,
		icon_url: "😚",
		text: "Possibly...remind me later.",
		extra_text: "",
	},
	{
		icon: true,
		icon_url: "👎",
		text: "Nope, I don't recommend things",
		extra_text: "",
	},
];

export const shoppingOptions = [
	{
		icon: true,
		icon_url: "😍",
		text: "Yes, show me products I might love!",
		extra_text: "Showing some products you might love!",
	},
	{
		icon: true,
		icon_url: "💌",
		text: "Not now, just email me anything I might love.",
		extra_text: "An email has been sent to you!",
	},
	{
		icon: true,
		icon_url: "⛔️",
		text: "No, I don’t even want the email.",
		extra_text: "Thank you for shopping with us",
	},
];

export const brandRowNumber = 3;
export const surveyResponseUrl = publisher
	? `${getApiUrl()}/core/survey_response/${publisher}/`
	: false;

export const INTERMEDIATE_SURVEY_RESPONSE_URL = publisher
	? `${getApiUrl()}/core/survey_response_follow_up/${publisher}/`
	: false;

export const rewardClaimUrl = publisher
	? `${getApiUrl()}/core/rewards_email/${publisher}/`
	: false;

export const FETCH_USER_URL = publisher
	? `${getApiUrl()}/identify/user/`
	: false;

export const getProductInfoUrl = publisher
	? `${getApiUrl()}/core/product_details/`
	: false;

// core/modules/<publisher_id>/
export const desktopOverlayUrl = publisher
	? `${getApiUrl()}/core/modules/${publisher}/`
	: false;

export const EDIT_OFFER_ORDER_URL =
	publisher && orderId
		? `${getApiUrl()}/core/edit_order/${publisher}/${orderId}/`
		: false;

export const BUCKET_NAME = process.env.REACT_APP_BUCKET,
	CLOUD_FRONT_URL = process.env.REACT_APP_CLOUDFRONT_DOMAIN;

export const UTM_PARAMS = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content",
];
export const DEFAULT_OFFER_IMAGE =
	"https://coopcommerce.s3-us-west-1.amazonaws.com/user_new.png";

export const DEFAULT_SHOP_IMG =
	"https://coopcommerce.s3-us-west-1.amazonaws.com/user_new.png";

export const CROSS_SELL_BANNER_IMAGE =
	"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/9f1a096d-1024-486f-83f9-d4ead07e3054_1617824600839_c13b-4c5c.png";

export const CROSS_SELL_LOGO_IMAGE =
	"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/9f1a096d-1024-486f-83f9-d4ead07e3054_1617824588272_c13b-4c5c.png";

export const EXTENSION_PREVIEW_SKIP_BTN_CLASS = "extension-preview-skip-btn";
export const EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY = () =>
	`${EXTENSION_PREVIEW_SKIP_BTN_CLASS}`;

// DUMMY PRODUCT INFO FOR TESTING OUT THE PDP
export const testProd = {
	id: 3890,
	name: "5 Panel Camp Cap",
	photo_url:
		"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/20210325221917/c13b-4c5c/7360bc44-8553-4fe2-9640-b4e1e6354ae6/original/c13b-4c5c/5-panel-hat_4ee20a27-8d5a-490e-a2fc-1f9c3beb7bf5.jpg",
	remote_id: "22c955dd-0f7b-4420-bbb8-5691c0228bc5",
	order: 0,
	price_str: null,
	discounted_price_str: "1.00",
	image_key:
		"20210325221917/c13b-4c5c/7360bc44-8553-4fe2-9640-b4e1e6354ae6/original/c13b-4c5c/5-panel-hat_4ee20a27-8d5a-490e-a2fc-1f9c3beb7bf5.jpg",
	masked_url:
		"https://coop-app-test-store.myshopify.com/products/5-panel-hat",
	variants: [
		{
			id: 196,
			shopify_variant_id: "37655828103345",
			option1_name: "Color",
			option1_value: "Heather Green",
			option2_name: "",
			option2_value: "",
			option3_name: "",
			option3_value: "",
			photo_url:
				"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/20210325221917/c13b-4c5c/7360bc44-8553-4fe2-9640-b4e1e6354ae6/original/c13b-4c5c/5-panel-hat_4ee20a27-8d5a-490e-a2fc-1f9c3beb7bf5.jpg",
			remote_id: "154e19ea-16be-41cc-bec0-88e585d5abb5",
			title: "Heather Green",
			price_str: null,
			discounted_price_str: "1.00",
			product_remote_id: "22c955dd-0f7b-4420-bbb8-5691c0228bc5",
			masked_url:
				"https://coop-app-test-store.myshopify.com/products/5-panel-hat",
			name: "5 Panel Camp Cap",
			order: 196,
		},
		{
			id: 197,
			shopify_variant_id: "37655828136113",
			option1_name: "Color",
			option1_value: "Burnt Orange",
			option2_name: "",
			option2_value: "",
			option3_name: "",
			option3_value: "",
			photo_url:
				"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/20210325221918/c13b-4c5c/7360bc44-8553-4fe2-9640-b4e1e6354ae6/original/c13b-4c5c/0010untitledAug2014.jpg",
			remote_id: "379d708a-4512-4819-bb57-e95aaadb9121",
			title: "Burnt Orange",
			price_str: null,
			discounted_price_str: "1.00",
			product_remote_id: "22c955dd-0f7b-4420-bbb8-5691c0228bc5",
			masked_url:
				"https://coop-app-test-store.myshopify.com/products/5-panel-hat",
			name: "5 Panel Camp Cap",
			order: 197,
		},
		{
			id: 198,
			shopify_variant_id: "37655828168881",
			option1_name: "Color",
			option1_value: "Slate Grey",
			option2_name: "",
			option2_value: "",
			option3_name: "",
			option3_value: "",
			photo_url:
				"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/20210325221918/c13b-4c5c/7360bc44-8553-4fe2-9640-b4e1e6354ae6/original/c13b-4c5c/5-panel-hat_4ee20a27-8d5a-490e-a2fc-1f9c3beb7bf5.jpg",
			remote_id: "aec48ee8-84e7-4c5c-8746-555613037384",
			title: "Slate Grey",
			price_str: null,
			discounted_price_str: "1.00",
			product_remote_id: "22c955dd-0f7b-4420-bbb8-5691c0228bc5",
			masked_url:
				"https://coop-app-test-store.myshopify.com/products/5-panel-hat",
			name: "5 Panel Camp Cap",
			order: 198,
		},
		{
			id: 199,
			shopify_variant_id: "37655828201649",
			option1_name: "Color",
			option1_value: "Navy Blue",
			option2_name: "",
			option2_value: "",
			option3_name: "",
			option3_value: "",
			photo_url:
				"https://coopcommerce-staging.s3-us-west-1.amazonaws.com/20210325221918/c13b-4c5c/7360bc44-8553-4fe2-9640-b4e1e6354ae6/original/c13b-4c5c/0010untitledAug2014.jpg",
			remote_id: "1fb8a4f6-1701-49bd-8ef8-f0994784ce19",
			title: "Navy Blue",
			price_str: null,
			discounted_price_str: "1.00",
			product_remote_id: "22c955dd-0f7b-4420-bbb8-5691c0228bc5",
			masked_url:
				"https://coop-app-test-store.myshopify.com/products/5-panel-hat",
			name: "5 Panel Camp Cap",
			order: 199,
		},
	],
	brand: "Test shop",
};

export const VYBES_PUBLISHER_ID = "5365ed27-2f7c-4ee7-aa85-ad1a5a8c3a72";
export const ROCKETS_PUBLISHER_ID = "53f7f80b-b300-4268-bce0-9b3c89f3bc37";
export const YUMI_PUBLISHER_ID = "08c0635f-3956-41e3-905c-272263fb8d22";
export const HONEST_STAGING_PUBLISHER_ID =
	"a8d9f04b-dd6a-4a0b-8fd1-670abd77358f";
export const HONEST_PUBLISHER_ID = "95a21c28-61c4-4d4f-9b4b-c64f556d362b";
export const MERIDIAN_PUBLISHER_ID = "7d069a1c-6969-4a9e-a4f1-4bb754470143";
export const LUMIN_PUBLISHER_ID = "cd57f149-fd10-4cce-80db-193febe6b141";

export const ROCKETS_BRAND_ID = 1988;
